export const WARNING_THRESHOLD = 20000
export const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'scroll']